import { Loader, Stack, Text } from "@mantine/core";

interface AuthLoadingProps {
    message?: string;
}

/** Full-screen branded loader shown while AuthKit is resolving the session. */
const AuthLoading: React.FC<AuthLoadingProps> = ({ message }) => (
    <Stack align='center' justify='center' gap='xl' style={{ overflow: 'hidden' }} h='100vh' bg='pq-red'>
        <Loader size='xl' color='white' />
        {message && <Text size='xl' c='white'>{message}</Text>}
    </Stack>
);

export default AuthLoading;


